module.exports = __webpack_public_path__ + "static/img/logo-calvin-klein.a9c2505.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/complete/logo-calvin-klein.png
// module id = NEXH
// module chunks = 0